module.exports = __webpack_public_path__ + "index-selected.png?8f4e544ed665de26be5bb139d3b7b727";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-selected.png
// module id = 131
// module chunks = 0